import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=9f36417a&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"
import style0 from "./Callback.vue?vue&type=style&index=0&id=9f36417a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f36417a",
  null
  
)

export default component.exports